import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export const AuthDialog = ({ open, onClose, onDone, mode0, claim }) => {
  const { login, register } = useAuth();
  const [mode, setMode] = useState(mode0 || "join");
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      if (mode === "join") await register({ ...f, account_type: "member" }); else await login(f.email, f.password);
      toast.success(mode === "join" ? "Welcome to the ShopAdvisor Directory" : "Signed in"); onDone();
    } catch (er) { toast.error(errMsg(er, "Couldn't sign you in")); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={v => !v && onClose()}>
      <DialogContent className="sm:max-w-md bg-white" data-testid="dir-auth-dialog">
        <DialogHeader><DialogTitle className="text-2xl font-extrabold" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>{mode === "join" ? (claim ? "Create your owner account" : "Join the directory") : "Welcome back"}</DialogTitle>
          <DialogDescription>{claim ? "Set your email and password. You'll use them to verify and manage your business page." : "Follow shops near you, like and comment on posts, and leave reviews."}</DialogDescription></DialogHeader>
        <div className="grid grid-cols-2 bg-slate-100 rounded-full p-1 text-sm font-semibold">{[["join", "Create account"], ["login", "Sign in"]].map(([k, l]) => <button key={k} type="button" onClick={() => setMode(k)} className={`py-1.5 rounded-full transition-colors ${mode === k ? "bg-white shadow text-slate-900" : "text-slate-500"}`} data-testid={`dir-auth-tab-${k}`}>{l}</button>)}</div>
        <form onSubmit={submit} className="space-y-3">
          {mode === "join" && <Input required placeholder="Your name" value={f.name} onChange={e => setF({ ...f, name: e.target.value })} data-testid="dir-auth-name" />}
          <Input required type="email" placeholder="Email" value={f.email} onChange={e => setF({ ...f, email: e.target.value })} data-testid="dir-auth-email" />
          <Input required type="password" minLength={mode === "join" ? 8 : 1} placeholder={mode === "join" ? "Password (8+ characters)" : "Password"} value={f.password} onChange={e => setF({ ...f, password: e.target.value })} data-testid="dir-auth-password" />
          <button disabled={busy} className="w-full h-11 rounded-full bg-slate-900 hover:bg-slate-700 text-white font-bold flex items-center justify-center gap-2 disabled:opacity-50" data-testid="dir-auth-submit">{busy && <Loader2 className="w-4 h-4 animate-spin" />}{mode === "join" ? "Create free account" : "Sign in"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
